import React from 'react';
import moment from "moment";

export const StockIndicator = (props) => {

    let items = [];

    let stockInStore = props.stockInStore;

    if(stockInStore < 0) {
        stockInStore = 0;
    }

    Array(stockInStore).fill(1).forEach(stock => items.push({quantity: 1, type: 'INSTOCK'}));

    props.pendingReplenishments.forEach(pendingRepl => {
        Array(pendingRepl.quantity).fill(1).forEach(pendingStock => items.push({
            quantity: 1,
            type: 'PENDING',
            createdAt: pendingRepl.createdAt
        }));
    });

    if (items.length < props.minimumStockQuantity) {
        const emptyStock = props.minimumStockQuantity - items.length;
        Array(emptyStock).fill(1).forEach(stock => items.push({quantity: 0, type: 'OUTOFSTOCK'}));
    }

    const renderContent = (stockItem) => {
        if (stockItem.type !== 'PENDING') return '';

        const createdAt = moment.utc(stockItem.createdAt).local();
        const createdAtDate = createdAt.format('DD.MM.YYYY');
        const createdAtTime = createdAt.format('HH:mm:ss');

        const pendingSince = moment.duration(moment().diff(createdAt));
        let pendingSinceDays = Math.floor(pendingSince.asDays());
        if (pendingSinceDays > 99) {
            pendingSinceDays = '!';
        }

        return <span title={createdAtDate + ' ' + createdAtTime}>{pendingSinceDays}</span>;
    };


    return items.map((stockItem, index) => {


        //#4dbd74
        const isMinStockItem = ((index + 1) === props.minimumStockQuantity);

        let bgColor = '#e2e2e2';
        let border = '1px solid #918f8f';

        if (stockItem.type === 'INSTOCK') {
            bgColor = '#4dbd74';
        }
        if (stockItem.type === 'PENDING') {
            bgColor = '#20a8d8';
        }

        if((index + 1) > props.minimumStockQuantity) {
            border = '2px solid red';
        }

        let minStockIndicatorStyle = {};

        if((index + 1) === props.minimumStockQuantity) {
            minStockIndicatorStyle = {
                width: '0',
                height: '0',
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderTop: '5px solid #000000',
                margin: '0 auto'
            };
        }

        return (
            <div key={index} style={{
                backgroundColor: bgColor,
                verticalAlign: 'middle',
                textAlign: 'center',
                color: 'white',
                border: border
            }}>
                <div style={minStockIndicatorStyle}></div>
                <div style={isMinStockItem ? {marginTop: '-5px'} : {}}>{renderContent(stockItem)}</div>
            </div>
        )
    })

};

export default StockIndicator;


// WEBPACK FOOTER //
// ./src/admin/components/StockIndicator.js